import { Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RichToolTipComponent } from '../../rich-tooltip.component';

@Component({
    selector: 'nova-match-breakdown-report-icon',
    templateUrl: './match-breakdown-report-icon.component.html',
    styleUrls: ['./match-breakdown-report-icon.component.scss'],
    standalone: true,
    imports: [MatIconModule, RichToolTipComponent]
})
export class MatchBreakdownReportIconComponent {
    displayText = input<string>();
    isMatchedClass = input<string>();
    isUnableToValidate = input<boolean>();
}
